/** Resolve backend API base URL (absolute hosts always include /api/v1). */
export function resolveApiBaseUrl(): string {
  const configured = (process.env.API_BACKEND_BASE_URL || '').trim();
  if (!configured || configured === 'undefined' || configured === 'null') {
    return '/api/v1';
  }

  let baseUrl = configured.replace(/\/$/, '');
  if (baseUrl.startsWith('http') && !baseUrl.includes('/api/v1')) {
    baseUrl = `${baseUrl}/api/v1`;
  }
  return baseUrl;
}
